<template>
  <div class="shop-list">
    <!--导航-->
    <div class="dk-nav">
      <van-nav-bar
              fixed
              title="客户详情"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>

    <!-- 详情 -->
    <template>
    <div>

      <div class="van-cell-group van-hairline--top-bottom van-panel" style="margin-bottom: 6px; font-size: 12px;">
        <div class="van-cell van-panel__header">
          <div class="van-cell__title">
            <span style="float: left;">姓名：{{hideName(detail.name)}}</span>
          </div>
        </div>
        <div class="van-cell van-panel__header">
          <div class="van-cell__title">
            <span style="float: left;">电话或微信号：{{ validatePhone(detail.phone)? hidePhone(detail.phone) : detail.phone}}</span>
          </div>
        </div>
        <div class="van-cell van-panel__header">
          <div class="van-cell__title">
            <span style="float: left;">加盟代理意向：{{detail.xuqiu}}</span>
          </div>
        </div>
        <div class="van-cell van-panel__header">
          <div class="van-cell__title">
            <span style="float: left;">客户来源：{{detail.kehulaiyuan}}</span>
          </div>
        </div>
        <div class="van-cell van-panel__header">
          <div class="van-cell__title">
            <span style="float: left;">报备人：{{detail.user_id}}</span>
          </div>
        </div>
        <div class="van-cell van-panel__header">
          <div class="van-cell__title">
            <span style="float: left;">报备日期：{{detail.created_at}}</span>
          </div>
        </div>
      </div>

      <div class="van-cell-group van-hairline--top-bottom van-panel" style="font-size: 12px;">
        <div class="van-cell van-panel__header">
          <div class="van-cell__title">
            <span>跟进情况：</span>
          </div>
        </div>
        <div class="van-panel__content">
            <div class="vant-content-v">{{detail.shuoming}}</div>
        </div>
      </div>

    </div>
    </template>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
export default {
    'name': 'ShopList',
    data() {
        return {

        };
    },
    computed: {
         ...mapState({
             detail: state => state.report.report_detail
         })
    },
    methods: {
        ...mapActions(['requestReportDetail']),
        onClickLeft() {
            this.$router.push({path: '/query'});
        },
        hidePhone(phone) {
           return phone.replace(/(\d{3})\d{4}(\d{4})/,'$1****$2');
        },
        hideName(name) {
           if (!name) return '';
           if (name.length === 2) {
             return name[0] + '*';
           } else if (name.length === 3) {
             return name[0] + '*' + name[2];
           }
           return name;
        },
        validatePhone(phone) {
          const reg = /^1[3-9]\d{9}$/
          return reg.test(phone)
        }
    },
    components: {

    },
    mounted() {
        this.requestReportDetail({"thit":this,"id":this.$route.params.id});
    },
    beforeCreate() {

    }
};
</script>

<style scoped>
.shop-list >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.shop-list >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.shop-list >>> .van-nav-bar__text {
  color: #fff;
}
.shop-list >>> .van-nav-bar__title {
  color: #fff;
}
.shop-list >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.shop-list >>> .van-nav-bar .van-icon {
  color: #fff;
}
/* 取消伪类 */
.dk-header-after::after {
  border-bottom:none;
}
.dk-footer-after::after {
  border-top:none;
}

.shop-list >>> .van-button--info {
    color: #fff;
    background-color: #ff8917;
    border: 0.02667rem solid #ff8917;
}
.vant-content-v {
  padding: 10px 20px 10px 20px;
}
</style>
